import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

export interface DashboardStudentV2PracticeDetail {
  sub_module_id: number;
  submodule_name: string;
  pass_questions: number;
  total_questions: number;
  percent: number;
}

export interface DashboardStudentV2Response {
  total_assigned: number;
  total_sub_module: number;
  completed: number;
  doing: number;
  not_started: number;
  total_question_success: number;
  total_questions: number;
  practice_details: DashboardStudentV2PracticeDetail[];
}

const initialState: any = {
  listStudentModule: [],
  practiceDashboardData: {},
  examDashboardData: {},
  classModuleStats: [],
  dashboardStudentV2: null as DashboardStudentV2Response | null,
  courseFilteringId: '',
  filterData: {
    module_id: null,
    start_date: dayjs().subtract(1, 'month').format('DD/MM/YYYY'),
    end_date: dayjs().format('DD/MM/YYYY')
  },
  loading: false,
  exportCompletionLoading: false,
  exportPracticeResultsLoading: false,
};

const studentDashboardSlice = createSlice({
  name: 'studentDashboard',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setPracticeDashboardData(state, action) {
      state.practiceDashboardData = action.payload;
    },
    setExamDashboardData(state, action) {
      state.examDashboardData = action.payload;
    },
    setClassModuleStats(state, action) {
      state.classModuleStats = action.payload;
    },
    setFilterData(state, action) {
      state.filterData = action.payload;
    },
    setListStudentModule(state, action) {
      state.listStudentModule = action.payload;
    },
    setDashboardStudentV2(state, action: PayloadAction<DashboardStudentV2Response | null>) {
      state.dashboardStudentV2 = action.payload;
    },
    setExportCompletionLoading(state, action: PayloadAction<boolean>) {
      state.exportCompletionLoading = action.payload;
    },
    setExportPracticeResultsLoading(state, action: PayloadAction<boolean>) {
      state.exportPracticeResultsLoading = action.payload;
    },
    resetStudentDashboardData(state) {
      state.practiceDashboardData = initialState.practiceDashboardData;
      state.examDashboardData = initialState.examDashboardData;
      state.classModuleStats = initialState.classModuleStats;
      state.dashboardStudentV2 = initialState.dashboardStudentV2;
      state.loading = initialState.loading;
      state.filterData = initialState.filterData;
    }
  },
});

export const {
  setLoading,
  setPracticeDashboardData,
  setExamDashboardData,
  setClassModuleStats,
  setFilterData,
  setListStudentModule,
  setDashboardStudentV2,
  setExportCompletionLoading,
  setExportPracticeResultsLoading,
  resetStudentDashboardData,
} = studentDashboardSlice.actions;

export default studentDashboardSlice.reducer;